import {DatePipe}                                   from '@angular/common';
import {booleanAttribute, Component, inject, input} from '@angular/core';
import {MedsListIntf, MedsRecordLogIntf}            from '@djsharkk/logr-types';
import {DataMedsService}                            from '../../../../logr-services/data/data-fire/data-meds.service';
import {TableRowBase}                               from '../table-row-base';
import {TableRow}                                   from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-meds',
			   imports: [
				   DatePipe
			   ],
			   templateUrl: './table-row-meds.component.html',
			   styleUrl   : './table-row-meds.component.css'
		   })
export class TableRowMedsComponent extends TableRowBase<MedsRecordLogIntf> {
	svcDataMeds = inject(DataMedsService)
	row = input.required<TableRow>();
	showDate = input(false, {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});

	medsItems: {
		[id: string]: MedsListIntf
	} = {};

	constructor() {
		super();
		this.svcDataMeds.medsList.subscribe(items => {
			this.medsItems = items.reduce(
				(acc, item) => {
					acc[item.id] = item;
					return acc;
				},
				{} as {
					[id: string]: MedsListIntf
				}
			);
		});
	}
}
